const Title = (props) => {
  return (
    <h1 className={`ec-title ${props.color}`}>
      <svg version="1.1" viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m12 17a2 2 0 0 1-3.4 0l-8.5-14a2 2 0 0 1 1.7-3h17a2 2 0 0 1 1.7 3z"
          fill="currentColor"
          data-name="Polygone 9"
        />
      </svg>

      {props.children}
    </h1>
  );
};

export default Title;
